var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.715,
    height: 55.217,
    viewBox: "0 0 44.715 55.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_26",
    "data-name": "Intersection 26",
    d: "M35.095,55.217a9.59,9.59,0,0,1-7.135-3.19H.7a.7.7,0,0,1-.7-.7V4.906a.7.7,0,0,1,.7-.7H8.317V.641A.641.641,0,0,1,8.959,0h2.724a.641.641,0,0,1,.641.641V1.656H24.8V.641A.641.641,0,0,1,25.44,0h2.724A.641.641,0,0,1,28.8.641V4.2h7.61a.7.7,0,0,1,.7.7V36.194a9.618,9.618,0,0,1-2.022,19.022ZM26.756,45.6a8.291,8.291,0,0,0,1.79,5.145.687.687,0,0,1,.287.343,8.331,8.331,0,1,0,7.7-13.693.61.61,0,0,1-.122.025.682.682,0,0,1-.33-.094A8.3,8.3,0,0,0,26.756,45.6ZM1.4,50.624H26.909a9.6,9.6,0,0,1,8.186-14.648c.209,0,.414.018.619.032V5.607H28.8V7.782a.641.641,0,0,1-.641.641H8.959a.641.641,0,0,1-.642-.641V5.607H1.4Zm8.2-46a.686.686,0,0,1,0,.556V7.141H27.523V5.191a.664.664,0,0,1,0-.571V1.282H26.08V2.3a.64.64,0,0,1-.641.641H11.683a.64.64,0,0,1-.641-.641V1.282H9.6ZM33.873,49.244l-3.579-3.009a.64.64,0,1,1,.824-.98l3.124,2.625L40.08,41.9a.641.641,0,1,1,.917.894L34.745,49.2a.64.64,0,0,1-.872.043ZM6.652,44a.641.641,0,0,1-.641-.641V36.873a.641.641,0,0,1,.641-.641h7.1a.641.641,0,0,1,.641.641v6.484a.641.641,0,0,1-.641.641Zm.641-1.282h5.815v-5.2H7.293Zm9.61-.47a.641.641,0,0,1,0-1.282h7.216a.641.641,0,1,1,0,1.282ZM16.9,39a.641.641,0,0,1,0-1.283h9.738a.641.641,0,0,1,0,1.283ZM6.652,33.4a.641.641,0,0,1-.641-.641V26.272a.641.641,0,0,1,.641-.641h7.1a.641.641,0,0,1,.641.641v6.484a.641.641,0,0,1-.641.641Zm.641-1.282h5.815v-5.2H7.293Zm9.61-.557a.641.641,0,0,1,0-1.282H31.447a.641.641,0,1,1,0,1.282Zm0-3.242a.641.641,0,0,1,0-1.282H31.447a.641.641,0,1,1,0,1.282ZM6.652,22.8a.641.641,0,0,1-.641-.641V15.671a.641.641,0,0,1,.641-.641h7.1a.641.641,0,0,1,.641.641v6.483a.641.641,0,0,1-.641.641Zm.641-1.282h5.815v-5.2H7.293Zm9.61-.557a.641.641,0,0,1,0-1.283H31.447a.641.641,0,0,1,0,1.283Zm0-3.242a.641.641,0,0,1,0-1.282H31.447a.641.641,0,1,1,0,1.282Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.1d87d5990d47b45c7fbcfc632398c77f.svg";
export { ForwardRef as ReactComponent };